import {workspaceAttributes} from "../../../../core/constants/headers";
import TableLayout from "../../../layout/main/TableLayout";
import {Column, Relative, Row} from "../../../../styles/CommonStyles";
import useGetTableIndex from "../../../../core/hooks/layout/useGetTableIndex";
import BooleanIcon from "../../../common/utils/BooleanIcon";
import DateTime from "../../../common/utils/DateTime";
import Operation from "../../../common/utils/Operation";
import {useNavigate} from "react-router-dom";
import NameTag from "../../../common/utils/NameTag";


const WorkspaceTable = ({ data }) => {

    const navigate = useNavigate()
    const { data: workspaces } = data
    const { headers, cs } = workspaceAttributes
    const { getTableIndex } = useGetTableIndex()

    const onDetailsClicked = (workspace) => navigate(`/reports/workspace/${workspace._id}`)

    return (
        <TableLayout
            headers={headers}
            cs={cs}
            data={data}
        >
            {workspaces?.data?.map((item,idx) => (
                <Relative>
                    <Row key={item._id} index={idx} cs={cs}>
                        <Column>
                            {getTableIndex(idx)}
                        </Column>
                        <Column>
                            <NameTag name={item.name} />
                        </Column>
                        <Column>
                            {item.code}
                        </Column>
                        <Column>
                            <BooleanIcon bool={item.isVerified} />
                        </Column>
                        <Column>
                            <BooleanIcon bool={item.isActive} />
                        </Column>
                        <Column center>
                            <DateTime dt={item.createdAt} />
                        </Column>
                    </Row>
                    <Column operation>
                        <Operation
                            onDetailsClicked={() => onDetailsClicked(item)}
                            hasDetails
                        />
                    </Column>
                </Relative>
            ))}
        </TableLayout>
    )
}


export default WorkspaceTable
